import { render, staticRenderFns } from "./ChatWhisperTile.vue?vue&type=template&id=630d4846&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatWhisperTile.vue"
export default component.exports